import _ from 'lodash';
import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Store } from '@ngrx/store';
import * as DialogActions from 'app/dialog/features/dialog.actions';
import { VIRTUAL_EVENT_STATUS } from '../../virtual-event.enums';
import { updateVirtualEventStream } from '../../features/data/data.actions';

const CUSTOM_RADIO_CONTROL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => StatusControlComponent),
  multi: true
}

@Component({
  selector: 'app-status-control',
  templateUrl: './status-control.component.html',
  styleUrls: ['./status-control.component.scss'],
  providers: [CUSTOM_RADIO_CONTROL_VALUE_ACCESSOR]
})
export class StatusControlComponent implements ControlValueAccessor {
  private _value: any = null;
  private onChange: (value: any) => {};

  get value() {
    return this._value;
  }

  @Input() event: any = null;
  @Input()
  set value(value) {
    this._value = value;
    this.onChange(value);
  }

  constructor(
    private store: Store
  ) { }

  writeValue(data: any) {
    switch(data) {
      case VIRTUAL_EVENT_STATUS.LOBBY:
        this.value = VIRTUAL_EVENT_STATUS.LOBBY;
        break;
      case VIRTUAL_EVENT_STATUS.START:
        const { event: { streamProvider, streamUrl } } = this;
        if(!_.isNumber(streamProvider) || streamProvider < 0 || streamProvider > 4 || (streamProvider < 4 && streamUrl === '')) {
          this.stepUpdateVirtualEvent();
        } else {
          this.value = VIRTUAL_EVENT_STATUS.START;
        }
        break;
      case VIRTUAL_EVENT_STATUS.END:
        this.value = VIRTUAL_EVENT_STATUS.END;
        break;
    }
    if(_.isObject(data)) {
      this._value = _.get(data, 'value', null);
    }
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched() {}

  generateConfirmAction(name, initialState) {
    return DialogActions.openDialog({
      payload: {
        name,
        options: {
          size: 'small',
          modalClass:'modal--paybee modal-sm',
          containerClass:'mdb-modal-backdrop-paybee'
        },
        initialState
      }
    });
  }

  generateUpdateAction(name, initialState) {
    return DialogActions.openDialog({
      payload: {
        name,
        options: {
          size: 'small',
          modalClass:'modal--paybee',
          containerClass:'mdb-modal-backdrop-paybee'
        },
        initialState
      }
    });
  }

  stepUpdateVirtualEvent() {
    const updateVirtualEventAction = this.generateUpdateAction("updateVirtualEventModal", {
      callback: ({ streamProvider, streamUrl }) => {
        const { event: { id: eventId } } = this;
        if (streamProvider !== 4) {
          this.store.dispatch({
            type: updateVirtualEventStream.type,
            payload: { eventId, streamProvider, streamUrl }
          });
        }
        this.value = VIRTUAL_EVENT_STATUS.START;
      }
    });
    this.store.dispatch(updateVirtualEventAction);
  }

}
